import { useState } from "react";
import { Alert, Form, Input, Modal } from "antd";
import { createInvitation } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  open: boolean;
  onClose(invited?: { email: string; token: string }): void;
}

const InviteMemberModal: React.FC<Props> = ({ open, onClose }) => {
  const organization = useOrganization();
  const [form] = Form.useForm<{ email: string }>();
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async ({ email }: { email: string }) => {
    setSubmitting(true);
    setError(null);
    try {
      const { invitation, token } = await createInvitation(organization, email);
      onClose({ email: invitation.email, token });
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Invite member"
      open={open}
      onCancel={() => onClose()}
      onOk={() => form.submit()}
      okText="Create invitation"
      confirmLoading={submitting}
      destroyOnHidden
      afterClose={() => {
        form.resetFields();
        setError(null);
      }}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        onValuesChange={() => setError(null)}
      >
        <Form.Item
          label="Email address"
          name="email"
          normalize={(value: string) => value.trim()}
          rules={[{ required: true, type: "email", message: "Enter a valid email address" }]}
        >
          <Input autoComplete="off" />
        </Form.Item>
        {error && <Alert type="error" title={error} />}
      </Form>
    </Modal>
  );
};

export default InviteMemberModal;
